import React, { PureComponent } from "react";

import { Col, Card, Row, Tabs, Pagination, Empty, Button, message } from "antd";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
// const { TabPane } = Tabs;
import "./index.scss";
// require ("./index.css");

const { TabPane } = Tabs;

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataList: [],
      dataInfo: {},
      activeKey: "1",
      defaultActiveKey:
        this.props.location.pathname &&
        this.props.location.pathname.split("/")[
          this.props.location.pathname.split("/").length - 1
        ] == 2
          ? "2"
          : "1",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.documentElement.scrollTo(0, 0);
    // http://127.0.0.1:280/blade-cms/cmsweb/currencyList?size=10&current=1&countyId=&tenantId=894699&categoryCode=job002  信息发布
    // /blade-cms/cmsarticle/list 政策汇总
    // console.log('dasdasdas',this.props);
    const {
      location: { pathname },
    } = this.props;
    console.log(
      "pathnamepathname",
      pathname.split("/")[pathname.split("/").length - 1]
    );

    if (pathname && pathname.split("/")[pathname.split("/").length - 1] == 2) {
      console.log(
        "pathnamepathname",
        pathname.split("/")[pathname.split("/").length - 1]
      );
      this.setState({ defaultActiveKey: "2" });
      this.onChange(2);
    } else {
      this.getInfoList();
    }
  }
  getInfoList = (data) => {
    const { activeKey } = this.state;
    let params = {
      current: 1,
      size: 10,
      descs: "release_time",
      ...data,
    };
    if (activeKey == 1) {
      Http.get(
        Request.getInfoList(),
        { ...params, categoryCode: "job002" },
        (obj) => {
          // return
          if (obj.code == 200) {
            this.setState({ dataList: obj.data.records, dataInfo: obj.data });
          } else {
            message.error(obj.msg || obj.message || "请求失败，请重试");
          }
        }
      );
    } else {
      Http.getApplication(
        Request.getInfoList1(),
        { ...params, categoryCode: "job001" },
        (obj) => {
          // return
          if (obj.code == 200) {
            this.setState({ dataList: obj.data.records, dataInfo: obj.data });
          } else {
            message.error(obj.msg || obj.message || "请求失败，请重试");
          }
        }
      );
    }
  };
  renderListInfo = (data) => {
    return data && data.length ? (
      data.map((item, index) => {
        return (
          <Row
            gutter={48}
            className="oneInfoBox"
            key={index}
            onClick={() =>
              this.props.history.push({
                pathname: "/entrance/PolicyDetails",
                state: { id: item.id, activeKey: this.state.activeKey },
              })
            }
          >
            <Col span={1} className="leftBox">
              <div className="point"></div>
            </Col>
            <Col
              span={47}
              className="rightBox"
              style={{ paddingLeft: "0px", paddingRight: "0px" }}
            >
              <div className="infoContent" title={item.title}>
                {item.title}
              </div>
              <div className="time">{item.releaseTime}</div>
            </Col>
          </Row>
        );
      })
    ) : (
      <Empty
        style={{
          width: "100%",
          height: "700px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          fontSize: "14px",
          color: "#999"
        }}
      />
    );
  };
  onChange = (e) => {
    console.log("222222", e);

    this.setState({ activeKey: `${e}`, dataInfo: {}, dataList: [] }, () =>
      this.getInfoList()
    );
  };
  sizeChange = (e) => {
    this.getInfoList({ current: e });
  };

  render() {
    const { dataInfo, dataList, defaultActiveKey } = this.state;
    console.log("defaultActiveKey", defaultActiveKey, typeof defaultActiveKey);

    const itemRender = (_, type, originalElement) => {
      if (type === "prev") {
        return <a>上一页</a>;
      }

      if (type === "next") {
        return <a>下一页</a>;
      }

      return originalElement;
    };
    return (
      <div>
        <div className="infoBox">
          <div className="conBox">
            <Tabs
              defaultActiveKey={`${defaultActiveKey}`}
              onChange={this.onChange}
            >
              <TabPane
                tab={<span style={{ fontSize: 18 }}>信息发布</span>}
                key="1"
              >
                {this.renderListInfo(dataList)}

                <div className="Pagination">
                  <span className="paginationBox">
                    <Pagination
                      total={dataInfo.total}
                      showSizeChanger={false}
                      showQuickJumper
                      showTotal={(total) => `共 ${total} 条`}
                      itemRender={itemRender}
                      onChange={this.sizeChange}
                      defaultCurrent={1}
                    />
                    <Button style={{ marginLeft: 10 }}>确定</Button>
                  </span>
                </div>
              </TabPane>
              <TabPane
                tab={<span style={{ fontSize: 18 }}>政策汇总</span>}
                key="2"
              >
                {this.renderListInfo(dataList)}

                <div className="Pagination">
                  <span className="paginationBox">
                    <Pagination
                      total={dataInfo.total}
                      showSizeChanger={false}
                      showQuickJumper
                      showTotal={(total) => `共 ${total} 条`}
                      itemRender={itemRender}
                      onChange={this.sizeChange}
                      defaultCurrent={1}
                    />
                    <Button style={{ marginLeft: 10 }}>确定</Button>
                  </span>
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
